module.exports = __webpack_public_path__ + "img/indu_active_14.6eb27589.png";